// Password recovery — the backend (/auth/forgot-password, /auth/reset-password) has existed since
// migration 077 but the console UI never exposed it (OPS-01). Enumeration-safe: the backend always
// returns success regardless of whether the email exists, so this page shows the same message
// either way.
import { type FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";

import { ApiError, apiPost } from "../api";

export default function ForgotPassword() {
  const [shopSlug, setShopSlug] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await apiPost("/auth/forgot-password", { shop_slug: shopSlug.trim(), email: email.trim() });
      setSent(true);
    } catch (e2) {
      // Still enumeration-safe on the happy path; only a genuine request failure (bad shape,
      // network) surfaces here.
      setErr(e2 instanceof ApiError ? e2.message : "Could not send the reset link — try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <Radio size={22} className="brand-icon" />
          <span>
            VendorIQ <b>Operations</b>
          </span>
        </div>
        <p className="auth-sub">Reset your console password.</p>
        {sent ? (
          <p className="cap-note">
            If that email exists on this store's console, a reset link is on its way (valid 1 hour).
          </p>
        ) : (
          <>
            <label>
              Store
              <input
                value={shopSlug}
                onChange={(e) => setShopSlug(e.target.value)}
                placeholder="your-store"
                autoComplete="organization"
                required
              />
            </label>
            <label>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </label>
            {err && <p className="err">{err}</p>}
            <button type="submit" className="primary" disabled={busy}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </>
        )}
        <p className="auth-hint">
          <Link to="/login">Back to sign in</Link>
        </p>
      </form>
    </div>
  );
}
